module.exports = __webpack_public_path__ + "static/media/dragon-tiger.fec6a516.svg";